import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { UUID } from "crypto";
import { ILoginResponse, NewProfile, ProfileCredentials, ProfileInfo, ResetPasswordRequest } from "../types/Types";

/**
 * @author noone
 */
export const LoginAPI = createApi({
    reducerPath: "loginAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "login/",
            prepareHeaders: (headers, { getState }) => {
                headers.set('Content-Type', 'application/json')
                headers.set('Accept', 'application/json');
                return headers;
            },
            credentials: 'include'
        }),
    tagTypes: ['userAPI'], // for caching
    endpoints: (builder) => ({
        login: builder.mutation<ILoginResponse, ProfileCredentials>({
            query: (requestParams: ProfileCredentials) => ({
                url: 'login',
                method: 'POST',
                body: requestParams,
            }),
        }),
        logout: builder.mutation<void, void>({
            query: () => ({
                url: 'logout',
                credentials: 'include',
                method: 'POST',
            })
        }),
        createAccount: builder.mutation<UUID, NewProfile>({
            query: (requestParams: NewProfile) => ({
                url: 'register',
                method: 'POST',
                body: {
                    email: requestParams.email,
                    password: requestParams.password,
                    countryCode: process.env.REACT_APP_COUNTRY_CODE,
                },
            })
        }),
        sendVerifyEmailAgain: builder.mutation<void, string>(
            {
                query: (requestParams: string) => ({
                    url: `sendverifyemailagain/${requestParams}`,
                    method: 'POST',
                    params: {},
                    credentials: 'include'
                })
            }
        ),
       resetPassword: builder.mutation<void, ResetPasswordRequest>(
            {
                query: (requestParams: ResetPasswordRequest) => ({
                    url: `resetPassword/${requestParams.uid}`,
                    method: 'PUT',
                    body: {
                        newPassword: requestParams.newPassword,
                        newPasswordRepeat: requestParams.newPasswordRepeat
                    },
                    credentials: 'include'
                })
            }
        ),
        requestNewPasswordMail: builder.mutation<void, string>(
            {
                
                query: (requestParams: string) => ({
                    url: 'resetPassword',
                    method: 'PUT',
                    params: {
                        email: requestParams
                    },
                    credentials: 'include'
                })
            }
        ),
        whoami: builder.mutation<ProfileInfo, void>(
            {
                query: () => ({
                    url: 'whoami',
                    method: 'post',
                    credentials: 'include'
                })
            }
        ),
    })
});

export const {
    useLoginMutation,
    useLogoutMutation,
    useCreateAccountMutation,
    useResetPasswordMutation,
    useSendVerifyEmailAgainMutation,
    useRequestNewPasswordMailMutation,
    useWhoamiMutation,

} = LoginAPI;
